import { VStack, Box, useDisclosure } from '@chakra-ui/react';
import { Link } from '@tanstack/react-router';
import { useState, type FC } from 'react';

import { Icon } from '$/components/common/Icon';
import { SchoolClassContextMenu } from '$/pages/SchoolClassesPage/components/SchoolClassContextMenu';
import { type SchoolClass } from '$/services/usecases/school/mapper/schoolClasses';
import { shortenText } from '$/utils/stringUtils';

interface Props {
  schoolClass: SchoolClass;
}

export const SchoolClassCard: FC<Props> = ({ schoolClass }) => {
  const [isHovered, setIsHovered] = useState(false);
  const showContextMenu = useDisclosure();

  return (
    <Link to='/classes/$id' params={{ id: schoolClass.id }}>
      <VStack
        layerStyle='WelcomeCard'
        pos='relative'
        overflow='hidden'
        bg='bodyBackground'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Icon icon='users' boxSize='40px' />
        <Box
          maxW='full'
          px='3'
          textOverflow='ellipsis'
          title={schoolClass.name}
        >
          {shortenText(schoolClass.name, 45)}
        </Box>
        <SchoolClassContextMenu
          visible={isHovered || showContextMenu.isOpen}
          {...showContextMenu}
          schoolClass={schoolClass}
        />
      </VStack>
    </Link>
  );
};
